// src/hooks/useVersionCheck.ts
import { useEffect, useState } from 'react';

/** 默认轮询间隔 */
const DEFAULT_POLL_INTERVAL: number = 30000;
/** 默认版本检查URL */
const DEFAULT_VERSION_CHECK_URL: string = '/version.json';

/** 版本检查钩子 */
const useVersionCheck = (pollInterval: number = DEFAULT_POLL_INTERVAL, versionCheckUrl: string = DEFAULT_VERSION_CHECK_URL) => {
    const [currentBuildId, setCurrentBuildId] = useState<string | null>(null);


    /** 应用启动时获取当前版本 */
    useEffect(() => {
        fetch(`${versionCheckUrl}?_t=${Date.now()}`, { cache: 'no-store' })
            .then(res => res.json())
            .then(data => setCurrentBuildId(data.buildId))
            .catch(err => console.error('获取版本信息失败:', err));
    }, []);

    /** 定期轮询检测 */
    useEffect(() => {
        /** 检查当前版本是否存在 */
        if (!currentBuildId || pollInterval < 1) return;

        /** 检查更新 */
        const checkUpdate = () => {
            fetch(`${versionCheckUrl}?_t=${Date.now()}`, { cache: 'no-store' })
                .then(res => res.json())
                .then(remote => {
                    if (remote.buildId && remote.buildId !== currentBuildId) {
                        console.log(`发现新版本: ${remote.buildId}，执行强制刷新`);
                        // 强制刷新，绕过缓存
                        const url = new URL(window.location.href);
                        url.searchParams.set('_force', Date.now().toString());
                        window.location.href = url.toString();
                    }
                }).catch(err => console.error('版本检测出错:', err));
        };

        /** 定时器 */
        const timer = setInterval(checkUpdate, pollInterval);
        return () => clearInterval(timer);
    }, [currentBuildId, pollInterval]);
}


export default useVersionCheck; 